import { Component, inject, signal } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import type { ActionButton } from '@shared/components/modals/custom-modal/models/action-button.models';
import { CustomDialogModalComponent } from '@shared/components/modals/custom-dialog-modal/custom-dialog-modal.component';
import { PrivacyPolicyComponent } from '@shared/components/modals/privacy-policy/privacy-policy.component';
import { ActionType } from '@core/auth/components/sign-in/components/accept-privacy-policy-modal/models/accept-privacy-policy.enum';
import { CookiePolicyComponent } from '@shared/components/modals/cookie-policy/cookie-policy.component';

@Component({
  selector: 'app-accept-privacy-policy-modal',
  templateUrl: './accept-privacy-policy-modal.component.html',
  styleUrls: ['./accept-privacy-policy-modal.component.scss'],
  standalone: true,
  imports: [CustomDialogModalComponent]
})
export class AcceptPrivacyPolicyModalComponent {
  private modalController = inject(ModalController);

  async openPrivacyPolicyDetails(event: Event): Promise<void> {
    event.preventDefault();

    const modal = await this.modalController.create({
      component: PrivacyPolicyComponent,
      cssClass: 'privacy-policy-modal',
      componentProps: {
        hideActionButtons: signal(true)
      }
    });

    await modal.present();
  }

  async openCookiePolicyDetails(event: Event): Promise<void> {
    event.preventDefault();

    const modal = await this.modalController.create({
      component: CookiePolicyComponent,
      cssClass: 'privacy-policy-modal',
      componentProps: {
        hideActionButtons: signal(true)
      }
    });

    await modal.present();
  }

  actionButtons = signal<ActionButton[]>([
    { text: 'Log Out', action: ActionType.logout, fill: 'solid', color: 'secondary' },
    { text: 'Accept', action: ActionType.accept, fill: 'solid', color: 'primary' }
  ]);

  handleAction(action: string): void {
    if (action === ActionType.accept) {
      this.modalController.dismiss({ accepted: true }).then();
    } else if (action === ActionType.logout) {
      this.modalController.dismiss({ accepted: false, logout: true }).then();
    }
  }
}
